import { Button, ButtonProps } from "react-admin";
import { SxProps, Theme } from "@mui/material";

/**
 * `GhostButton` is a low-emphasis button used for tertiary actions.
 *
 * It looks like an outlined button with neutral color — intended for UI actions
 * that are optional, non-primary, or serve as alternatives (e.g., "Create manually").
 *
 * Use this when:
 * - You want a button to look available but not visually dominant.
 * - The action is not critical to completing the flow.
 *
 * It inherits all props from the React Admin `Button`.
 */
export const GhostButton = ({ sx, ...props }: ButtonProps & { sx?: SxProps<Theme> }) => {
  return (
    <Button
      variant="outlined"
      {...props}
      sx={{
        borderColor: "divider",
        color: "inherit",
        "&:hover": {
          borderColor: "rgba(0, 0, 0, 0.12)",
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
        ...sx,
      }}
    />
  );
};
